import axios from 'axios';

import { handleApiSucess, handleApiError, getRequestHeaders } from 'api/util.api';
import { handleRequest } from './util.api';

const getCostCentersUrl = (cId, sId) => `/companies/${cId}/subcompanies/${sId}/cost_centers`;

const getCostCenterByIdUrl = (dId, cId, sId) =>
  `/companies/${cId}/subcompanies/${sId}/cost_centers/${dId}`;

const addCostCenterUrl = (cId, sId) => `/companies/${cId}/subcompanies/${sId}/cost_centers`;

const updateCostCenterUrl = (dId, cId, sId) =>
  `/companies/${cId}/subcompanies/${sId}/cost_centers/${dId}`;

const toggleCostCenterUrl = (dId, cId, sId) =>
  `/companies/${cId}/subcompanies/${sId}/cost_centers/${dId}/toggle`;

const formConfigUrl = (cId, sId) =>
  `/companies/${cId}/subcompanies/${sId}/cost_centers/form_config`;

// export const gets = ( companyId, subcompanyId, filters, limit, page, orderBy, order ) =>
//   async ( ApiSucess = handleApiSucess, ApiError = handleApiError, { axios }, getHeaders ) => {
//     const url = getCostCentersUrl(companyId, subcompanyId);
//     const params = { ...filters, limit, page, orderBy, order };
//     try {
//       return await axios
//         .get(url, { ...getHeaders(), params })
//         .then(ApiSucess); //return result.data
//     } catch (e) {
//       return ApiError(e); // return Promise.reject(err.data)
//     }
//   };
/*

  get2: ( companyId, subcompanyId, filters, limit, page, orderBy, order ) =>
    async(dispatch, getState, {axios}) => {
  // async ( ApiSucess = handleApiSucess, ApiError = handleApiError, { axios } , getHeaders = this.getHeaders ) => {
    // if(axios == undefined) axios = this.axios;
    const url = getCostCentersUrl(companyId, subcompanyId);
    const params = { ...filters, limit, page, orderBy, order };
    try {
      console.log(axios)
      return await axios
        .get(url, { ...this.getHeaders(), params })
        .then(handleApiSucess); //return result.data
    } catch (e) {
      return handleApiError(e); // return Promise.reject(err.data)
    }
  },
*/
const service = {
  configure(endpoint = '', auth = {}, defaultHeaders = {}) {
    this.endpoint = endpoint;
    this.auth = auth;
    this.defaultHeaders = defaultHeaders;
    this.getHeaders = getRequestHeaders(this.auth, this.defaultHeaders);

    this.axios = axios.create({
      baseURL: this.endpoint,
      timeout: 30000,
    });

    this.axios.interceptors.request.use((request) => {
      handleRequest(request);
      return request;
    });

    return this;
  },

  get(companyId, subcompanyId, filters, limit, page, orderBy, order) {
    const url = getCostCentersUrl(companyId, subcompanyId);
    const params = { ...filters, limit, page, orderBy, order };
    return this.axios
      .get(url, { ...this.getHeaders(), params })
      .then(handleApiSucess)
      .catch(handleApiError);
  },
  getById(costCenterId, companyId, subcompanyId) {
    const url = getCostCenterByIdUrl(costCenterId, companyId, subcompanyId);
    return this.axios
      .get(url, { ...this.getHeaders() })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  add(companyId, subcompanyId, costCenter) {
    const url = addCostCenterUrl(companyId, subcompanyId);

    return this.axios
      .post(url, costCenter, { ...this.getHeaders() })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  update(costCenterId, companyId, subcompanyId, costCenter) {
    const url = updateCostCenterUrl(costCenterId, companyId, subcompanyId);

    return this.axios
      .put(url, costCenter, { ...this.getHeaders() })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  toggle(costCenterId, companyId, subcompanyId) {
    const url = toggleCostCenterUrl(costCenterId, companyId, subcompanyId);
    return this.axios
      .put(url, {}, { ...this.getHeaders() })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  formConfig(companyId, subcompanyId) {
    const url = formConfigUrl(companyId, subcompanyId);
    return this.axios
      .get(url, { ...this.getHeaders() })
      .then(handleApiSucess)
      .catch(handleApiError);
  },
};

export default service;



// WEBPACK FOOTER //
// src/lib/api/costCenters.api.js